
<template>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="12"
			cy="12"
			r="12"
			fill="#2A8176"
		/>
		<path
			d="M17.7138 7.71466L9.85665 15.5718L6.28522 12.0004"
			stroke="white"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

